import simg1 from '../images/service/1.png'
import simg2 from '../images/service/2.png'
import simg3 from '../images/service/3.png'
import simg4 from '../images/service/4.png'
import simg5 from '../images/service/5.png'
import simg6 from '../images/service/6.png'
import simg7 from '../images/service/img-01.jpg'
import simg8 from '../images/service/img-02.jpg'
import simg9 from '../images/service/img-03.jpg'
import simg10 from '../images/service/img-04.jpg'
import simg11 from '../images/service/img-05.jpg'

import sSimg1 from '../images/service-single/img-1.jpg'
import sSimg2 from '../images/service-single/img-2.jpg'
import sSimg3 from '../images/service-single/img-3.jpg'
import sSimg4 from '../images/service-single/img-4.jpg'
import sSimg5 from '../images/service-single/img-5.jpg'
import sSimg6 from '../images/service-single/img-6.jpg'
import sSimg7 from '../images/service-single/img-7.jpg'
import sSimg8 from '../images/service-single/img-8.jpg'
import sSimg9 from '../images/service-single/img-9.jpg'
import sSimg10 from '../images/service-single/img-10.jpg'
import sSimg11 from '../images/service-single/img-11.jpg'
import sSimg12 from '../images/service-single/img-12.jpg'
import sSimg13 from '../images/service-single/img-13.jpg'
import sSimg14 from '../images/service-single/img-14.jpg'



const Services = [
   {
      Id: '01',
      sImg: simg1,
      sSImg: sSimg1,
      title: 'Content Marketing',
      Subtitle: 'Excellent Performance',
      slug: 'Quran-Memorization',
      description: 'It seem that only fragmen the original remain.',
   },
   {
      Id: '02',
      sImg: simg2,
      sSImg: sSimg2,
      title: 'E-mail Marketing',
      Subtitle: 'Excellent Performance',
      slug: 'Special-Child-Care12',
      description: 'It seem that only fragmen the original remain',
   },
   {
      Id: '03',
      sImg: simg3,
      sSImg: sSimg3,
      title: 'Webflow Development',
      Subtitle: 'Excellent Performance',
      slug: 'Quran-Memorization21',
      description: 'It seem that only fragmen the original remain.',
   },
   {
      Id: '04',
      sImg: simg4,
      sSImg: sSimg4,
      title: 'Social Media Marketing',
      Subtitle: 'Excellent Performance',
      slug: 'Marketing12',
      description: 'It seem that only fragmen the original remain',
   },
   {
      Id: '05',
      sImg: simg5,
      sSImg: sSimg5,
      title: 'Digital Marketing',
      Subtitle: 'Excellent Performance',
      slug: 'Quran-Memorization214',
      description: 'It seem that only fragmen the original remain.',
   },
   {
      Id: '06',
      sImg: simg6,
      sSImg: sSimg6,
      title: 'Website Designing',
      Subtitle: 'Excellent Performance',
      slug: 'Marketingj12',
      description: 'It seem that only fragmen the original remain',
   },
   {
      Id: '07',
      sImg: simg7,
      sSImg: sSimg7,
      title: '01. UI/UX Design',
      Subtitle: 'Excellent Performance',
      slug: 'UI-UX-Design',
      description: 'It seem that only fragmen the original remain',
   },
   {
      Id: '08',
      sImg: simg8,
      sSImg: sSimg8,
      title: '02. digital marketing',
      Subtitle: 'Excellent Performance',
      slug: 'digital-marketing',
      description: 'It seem that only fragmen the original remain',
   },
   {
      Id: '09',
      sImg: simg9,
      sSImg: sSimg9,
      title: '03. branding design',
      Subtitle: 'Excellent Performance',
      slug: 'branding-design9',
      description: 'It seem that only fragmen the original remain',
   },
   {
      Id: '10',
      sImg: simg10,
      sSImg: sSimg10,
      title: '04. motion designing',
      Subtitle: 'Excellent Performance',
      slug: 'motion-designing10',
      description: 'It seem that only fragmen the original remain',
   },
   {
      Id: '11',
      sImg: simg11,
      sSImg: sSimg11,
      title: '05. Email Marketing',
      Subtitle: 'Excellent Performance',
      slug: 'Email-Marketing11',
      description: 'It seem that only fragmen the original remain',
   },
   {
      Id: '12',
      sImg: simg11,
      sSImg: sSimg12,
      title: '01.Marketing Strategy',
      Subtitle: 'Excellent Performance',
      slug: 'Email-Marketing12',
      description: 'We closely collaborate with our clients to understand the needs and goals of the key to design',
   },
   {
      Id: '13',
      sImg: simg11,
      sSImg: sSimg13,
      title: '02. Branding Design',
      Subtitle: 'Excellent Performance',
      slug: 'Email-Marketing13',
      description: 'We closely collaborate with our clients to understand the needs and goals of the key to design',
   },
   {
      Id: '14',
      sImg: simg11,
      sSImg: sSimg14,
      title: '03. Design & Multimedia',
      Subtitle: 'Excellent Performance',
      slug: 'Email-Marketing14',
      description: 'We closely collaborate with our clients to understand the needs and goals of the key to design',
   },


]

export default Services;